import React from 'react';
import { Promise } from 'es6-promise';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import DeleteIcon from '@material-ui/icons/Delete';

import CreateGroup from './create-group';
import AuthorizedDevices from './authorized-devices';
import Filters from './filters';
import Groups from './groups';
import GroupSelector from './groupselector';
import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';
import AppConstants from '../../constants/app-constants';
import { preformatWithRequestID, getUserRoleFromJWT } from '../../helpers';

const UNGROUPED_GROUP = AppConstants.UNGROUPED_GROUP;

export default class DeviceGroups extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      groups: AppStore.getGroups(),
      currentUserRole: getUserRoleFromJWT(),
      selectedGroup: AppStore.getSelectedGroup(),
      addGroup: false,
      removeGroup: false,
      groupInvalid: true,
      filters: AppStore.getFilters(),
      attributes: AppStore.getFilterAttributes(),
      createGroupDialog: false,
      devices: [],
      acceptedDevices: [],
      ungroupedDevices: [],
      pageNo: 1,
      pageLength: 20,
      loading: true,
      tmpDevices: [],
      allDevices: [],
      allDevUuidsPairs: [],
      refreshDeviceLength: 10000,
      isHosted: window.location.hostname === 'hosted.mender.io',
      count: 0
    };
    const {filters=''} = context.router.route.match.params || {};
    if (filters) {
      if (filters[0] == 'i') {
        this.state.filters = [{'key': 'id', 'dev_id': filters.slice(3)}];
      }
    }

    /** Bind methods */
    this._openGroupDialogBind = this._openGroupDialog.bind(this);
    this._handleGroupChangeBind = this._handleGroupChange.bind(this);
    this._onFilterChangeBind = this._onFilterChange.bind(this);
    this._addDevicesToGroupBind = this._addDevicesToGroup.bind(this);
    this._handlePageChangeBind = this._handlePageChange.bind(this);
    this._getAllDataBind = this._getAllData.bind(this);
    this._removeDevicesFromGroupBind = this._removeDevicesFromGroup.bind(this);
    this._toggleDialogBind = this._toggleDialog.bind(this);
    this._triggerRefreshTimerBind = this._triggerRefreshTimer.bind(this);
    this._createGroupFromDialogBind = this._createGroupFromDialog.bind(this);

    /** local property */
    this._unmountError = 'Component unmounted';
  }

  componentDidMount() {
    this._isMounted = true;
    this._getAllData();
  }

  componentWillUnmount() {
    this._triggerRefreshTimer(false);
    this._isMounted = false;
  }

  _getAllData() {
    this._triggerRefreshTimer(false);
    Promise.all([AppActions.getGroups(), this._getDevices(), this._getAllDeviceUUID()])
      .then((results) => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
        return results;
      })
      .then((results) => {
        const [count, devices] = results[1];
        results[0].push(UNGROUPED_GROUP.id);
        this.setState(() => ({groups: results[0], devices, count, loading: false, allDevUuidsPairs: results[2]}), () => {
          this._triggerRefreshTimer(true);
        });
      })
      .catch((err) => {
        if (err.message !== this._unmountError) {
          this.setState(() => ({groups: [], devices: [], count: 0, loading: false, allDevUuidsPairs: []}), () => {
            this._triggerRefreshTimer(true);
          });
        }
      });
  }

  _getDevices() {
    return new Promise((resolve, reject) => {
      const {filters, selectedGroup, pageNo, pageLength} = this.state;
      let promises = [];
      //As of now only filter support one device id
      if (filters.length && (filters[0].value || filters[0].dev_id)) {
        promises = [Promise.resolve(1), Promise.resolve([{'id':filters[0].dev_id}])];
      } else if (selectedGroup) {
        const group = this._isUngroupedGroup(selectedGroup) ? '' : selectedGroup;
        const param = this._isUngroupedGroup(selectedGroup) ? 'has_group=false' : `group=${selectedGroup}`;
        promises = [AppActions.getNumberOfDevicesInGroup(group), AppActions.getDevices(pageNo, pageLength, param)];
      } else {
        promises = [AppActions.getDeviceCount('accepted'), AppActions.getDevicesByStatus('accepted', pageNo, pageLength)];
      }
      Promise.all(promises)
        .then((results) => {
          return this._getDeviceDetails(results);
        })
        .then((results) => {
          resolve(results);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  _getAllDeviceUUID() {
    return new Promise((resolve, reject) => {
      AppActions.getAllDevices()
        .then((devices) => {
          const allDevUuidsPairs = [];
          const deviceLen = devices.length;
          for (let i=0; i<deviceLen; i++) {
            const device = devices[i];
            if (device.attributes) {
              const attributeLen = device.attributes.length;
              for (let j=0; j<attributeLen; j++) {
                const attribute = device.attributes[j];
                if (attribute.name == 'UUID') {
                  allDevUuidsPairs.push({'dev_id': device.id,'uuid': attribute.value});
                  break;
                }
              }
            }
          }
          resolve(allDevUuidsPairs);
        })
        .catch((err) => {
          reject(err);
        })
    });
  }

  // _getAllDeviceUUID() {
  //   return new Promise((resolve) => {
  //     resolve([]);
  //   });
  // }

  _getDeviceAttrAndOthers(device) {
    return Promise.all([AppActions.getDeviceById(device.id), AppActions.getConfigById(device.id),
      AppActions.getLocalConfigById(device.id), AppActions.getActionByDeviceId(device.id)])
      .then((results) => {
        const inventory = results[0];
        const config = results[1];
        const localConfig = results[2];
        const action = results[3];
        //inventory
        device.attributes = inventory.attributes;
        device.updated_ts = inventory.updated_ts;
        //config
        device.configInfo = config;
        device.type = config.flavor.type;
        device.label = localConfig.label;
        device.config_name = config.configuration.name;
        device.flavor_name = config.flavor.name;
        //localConfig Info
        device.localConfInfo = localConfig;
        //action Info
        device.actionInfo = action;
        return Promise.resolve(device);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }

  _getDeviceAuthAndOthers(device) {
    return Promise.all([AppActions.getDeviceAuth(device.id), AppActions.getConfigById(device.id),
      AppActions.getLocalConfigById(device.id), AppActions.getActionByDeviceId(device.id)])
      .then((results) => {
        const auth = results[0];
        const config = results[1];
        const localConfig = results[2];
        const action = results[3];
        //Auth
        device.identity_data = auth.identity_data;
        device.auth_sets = auth.auth_sets;
        device.status = auth.status;
        //Config
        device.configInfo = config;
        device.type = config.flavor.type;
        device.label = localConfig.label;
        device.config_name = config.configuration.name;
        device.flavor_name = config.flavor.name;
        //localConfig Info
        device.localConfInfo = localConfig;
        //action Info
        device.actionInfo = action;
        return Promise.resolve(device);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }

  _getDeviceAllDetails(device) {
    return Promise.all([AppActions.getDeviceById(device.id), AppActions.getDeviceAuth(device.id), AppActions.getConfigById(device.id),
      AppActions.getLocalConfigById(device.id), AppActions.getActionByDeviceId(device.id)])
      .then((results) => {
        const inventory = results[0];
        const auth = results[1];
        const config = results[2];
        const localConfig = results[3];
        const action = results[4];
        //inventory
        device.attributes = inventory.attributes;
        device.updated_ts = inventory.updated_ts;
        //Auth
        device.identity_data = auth.identity_data;
        device.auth_sets = auth.auth_sets;
        device.status = auth.status;
        //Config
        device.configInfo = config;
        device.type = config.flavor.type;
        device.label = localConfig.label;
        device.config_name = config.configuration.name;
        device.flavor_name = config.flavor.name;
        //localConfig Info
        device.localConfInfo = localConfig;
        //action Info
        device.actionInfo = action;
        return Promise.resolve(device);
      })
      .catch((err) => {
        throw new Error(err);
      });
  }

  _getDeviceDetails([count, devices]) {
    return new Promise((resolve, reject) => {
      if (!count || !devices.length) {
        resolve([0, []]);
      } else {
        const detailReq = devices.map((device) => {
          // have to call inventory each time - accepted list can change order so must refresh inventory too
          if (device.attributes) {
            return this._getDeviceAuthAndOthers(device);
          } else if (device.status) {
            return this._getDeviceAttrAndOthers(device);
          } else {
            return this._getDeviceAllDetails(device);
          }
        });
        Promise.all(detailReq)
          .then((results) => {
            resolve([count, results]);
          })
          .catch((err) => {
            reject(err);
          });
      }
    });
  }

  _triggerRefreshTimer(trigger) {
    if (trigger && !this.timerId && this._isMounted) {
      this.timerId = setTimeout(() => {this._getAllData()}, this.state.refreshDeviceLength);
    } else if(!trigger && this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  _handleGroupChange(group) {
    this._triggerRefreshTimer(false);
    this.setState({count: 0, devices: [], loading: true, selectedGroup: group, pageNo: 1, filters: []}, () => {
      this._getDevices()
        .then((results) => {
          if (!this._isMounted) {
            throw new Error(this._unmountError);
          }
          return results;
        })
        .then((results) => {
          const [count, devices] = results;
          this.setState(() => ({count, devices, loading: false, groupCount: count}), () => {
            this._triggerRefreshTimer(true)
          });
        })
        .catch((err) => {
          if (err.message !== this._unmountError) {
            this.setState(() => ({count: 0, devices: [], loading: false, groupCount: 0}), () => {
              this._triggerRefreshTimer(true)
            });
          }
        });
    });
  }

  _handlePageChange(pageNo) {
    this._triggerRefreshTimer(false);
    this.setState({pageLoading: true, pageNo}, () => {
      this._getDevices()
        .then((results) => {
          if (!this._isMounted) {
            throw new Error(this._unmountError);
          }
          return results;
        })
        .then((results) => {
          const [count, devices] = results;
          this.setState(() => ({count, devices, loading: false}), () => {
            this._triggerRefreshTimer(true);
          });
        })
        .catch((err) => {
          if (err.message !== this._unmountError) {
            this.setState(() => ({count: 0, devices: [], loading: false}), () => {
              this._triggerRefreshTimer(true);
            });
          }
        });
    });
  }

  /*
   * Groups
   */

  _removeCurrentGroup() {
    this._triggerRefreshTimer(false);
    const {count, selectedGroup} = this.state;
    const params = selectedGroup ? `group=${selectedGroup}` : '';

    AppActions.getDevices(1, count, params)
      .then((devices) => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
        return devices;
      })
      .then((devices) => {
        const promises = devices.map((device) => {
          return AppActions.removeDeviceFromGroup(device.id, selectedGroup);
        });
        return Promise.all(promises);
      })
      .then(() => {
        this.setState(() => ({selectedGroup: null, devices: [], count: 0, pageNo: 1, loading: true, removeGroup: false}), () => {
          AppActions.setSnackbar('Group was removed successfully', 5000);
          this._getAllData();
        });
      })
      .catch((err) => {
        if (err.message !== this._unmountError) {
          this.setState(() => ({selectedGroup: null, devices: [], count: 0, pageNo: 1, loading: true, removeGroup: false}), () => {
            AppActions.setSnackbar('Group is not removed successfully, pleaes check your connection', 5000);
            this._getAllData();
          });
        }
      });
  }

  _isUngroupedGroup(group) {
    if (!group) {
      return false;
    }
    return group === UNGROUPED_GROUP.id || group === UNGROUPED_GROUP.name;
  }

  // Edit groups from device selection
  _addDevicesToGroup(devices) {
    var self = this;
    // (save selected devices in state, open dialog)
    self.setState({ tmpDevices: devices, addGroup: !self.state.addGroup });
  }

  _validate(invalid, group) {
    var name = invalid ? '' : group;
    this.setState({ groupInvalid: invalid, tmpGroup: name });
  }
  _changeTmpGroup(group) {
    this.setState({ selectedField: group, tmpGroup: group });
  }
  _addToGroup() {
    this._triggerRefreshTimer(false);
    const {tmpDevices, selectedField, tmpGroup, devices} = this.state;
    const group = selectedField || tmpGroup;
    const promises = tmpDevices.map((idx) => {
      return AppActions.addDeviceToGroup(group, devices[idx].id);
    });
    Promise.all(promises)
      .then(() => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
      })
      .then(() => {
        this.setState(() => ({createGroupDialog: false, addGroup: false, tmpGroup: '', selectedField: '', tmpDevices: [],
          loading: true, selectedGroup: group, pageNo: 1, filters: []}), () => {
          AppActions.setSnackbar('The group was updated successfully', 5000);
          this._getAllData();
        });
      })
      .catch((err) => {
        if (err.message !== this._unmountError) {
          this.setState(() => ({createGroupDialog: false, addGroup: false, tmpGroup: '', selectedField: '', tmpDevices: [],
            selectedGroup: null, filters: [], pageNo: 1, loading: true, removeGroup: false}), () => {
            AppActions.setSnackbar('Group is not updated successfully, pleaes check your connection', 5000);
            this._getAllData();
          });
        }
      });
  }

  _createGroupFromDialog(devices, group) {
    this._triggerRefreshTimer(false);
    const promises = devices.map((device) => {
      return AppActions.addDeviceToGroup(group, device.id)
    });
    Promise.all(promises)
      .then(() => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
      })
      .then(() => {
        const state = {createGroupDialog: false, addGroup: false, tmpGroup: '', selectedField: '',
          count: 0, devices: [], loading: true, selectedGroup: group, pageNo: 1, filters: []};
        this.setState(state, () => {
          AppActions.setSnackbar('The group was updated successfully', 5000);
          this._getAllData();
        });
      })
      .catch((err) => {
        if (err.message !== this._unmountError) {
          var errMsg = err.res.body.error || '';
          this.setState({createGroupDialog: false, addGroup: false, tmpGroup: '', selectedField: ''}, () => {
            AppActions.setSnackbar(preformatWithRequestID(err.res, `Group could not be updated: ${errMsg}`), null, 'Copy to clipboard');
            this._getAllData();
          });
        }
      });
  }

  _removeDevicesFromGroup(rows) {
    this._triggerRefreshTimer(false);
    const {devices, selectedGroup} = this.state;
    const isPageRemoval = devices.length > rows.length;
    const promises = rows.map((idx) => {
      return AppActions.removeDeviceFromGroup(devices[idx].id, selectedGroup);
    });
    Promise.all(promises)
      .then(() => {
        if (!this._isMounted) {
          throw new Error(this._unmountError);
        }
      })
      .then(() => {
        const newState = isPageRemoval ? {loading: true, pageNo: 1, devices: [], count: 0, groupCount: 0} :
          {loading: true, pageNo: 1, devices: [], count: 0, groupCount: 0, selectedGroup: null};
        const msg = isPageRemoval ? `The ${pluralize('devices', rows.length)} ${pluralize('were', rows.length)} removed from the group` :
          'The group was removed successfully';
        this.setState(() => newState, () => {
          AppActions.setSnackbar(msg, 5000);
          this._getAllData();
        });
      })
      .catch((err) => {
        if (err.message !== this._unmountError) {
          AppActions.setSnackbar('Move/Remove selected device failed, please check your connection', 5000);
          this._getAllData();
        }
      });
  }

  _onFilterChange(newFilters) {
    const {filters} = this.state;
    if (filters.length !== newFilters.length) {
      this.setState(() => ({filters: newFilters, pageNo: 1, loading: true}), () => {
        AppStore.setFilters(newFilters);
        this._getDevices()
          .then((results) => {
            if (!this._isMounted) {
              throw new Error(this._unmountError);
            }
            return results;
          })
          .then((results) => {
            this.setState(() => ({count: results[0], devices: results[1], loading: false}));
          })
          .catch((err) => {
            if (err.message !== this._unmountError) {
              this.setState(() => ({count: 0, devices: [], loading: false}));
            }
          });
      });
    }
  }

  _openGroupDialog() {
    this.setState({ createGroupDialog: !this.state.createGroupDialog });
  }

  _toggleDialog() {
    this.setState({ createGroupDialog: !this.state.createGroupDialog });
  }

  render() {
    const self = this;
    // Add to group dialog
    var addActions = [
      <Button key="add-action-button-1" style={{ marginRight: '10px' }} onClick={() => self.setState({ addGroup: !self.state.addGroup })}>
        Cancel
      </Button>,
      <Button variant="contained" key="add-action-button-2" color="primary" onClick={() => this._addToGroup()} disabled={this.state.groupInvalid || this.state.currentUserRole !== 'admin'}>
        Add to group
      </Button>
    ];

    var removeActions = [
      <Button key="remove-action-button-1" onClick={() => self.setState({ removeGroup: !self.state.removeGroup })} style={{ marginRight: '10px' }}>
        Cancel
      </Button>,
      <Button variant="contained" key="remove-action-button-2" color="primary" onClick={() => this._removeCurrentGroup()} disabled={this.state.currentUserRole !== 'admin'} >
        Remove group
      </Button>
    ];
    const acceptedDevices = AppStore.getTotalAcceptedDevices();
    var groupCount = this.state.groupCount || acceptedDevices || 0;

    var groupName = this._isUngroupedGroup(this.state.selectedGroup) ? UNGROUPED_GROUP.name : this.state.selectedGroup;
    var allowDeviceGroupRemoval = !this._isUngroupedGroup(this.state.selectedGroup);

    return (
      <div className="tab-container">
        <div className="leftFixed">
          <Groups
            openGroupDialog={this._openGroupDialogBind}
            changeGroup={this._handleGroupChangeBind}
            groups={this.state.groups}
            selectedGroup={this.state.selectedGroup}
            acceptedCount={acceptedDevices}
          />
        </div>
        <div className="rightFluid" style={{ paddingTop: '0' }}>
          {!this.state.selectedGroup ? (
            <Filters
              attributes={this.state.attributes}
              filters={this.state.filters}
              allUUIDs={this.state.allDevUuidsPairs}
              onFilterChange={this._onFilterChangeBind}
              isHosted={this.state.isHosted}
            />
          ) : null}

          {self.state.selectedGroup && allowDeviceGroupRemoval ? (
            <Button
              style={{ position: 'absolute', top: 0, right: '30px', zIndex: 100 }}
              disabled={this.state.currentUserRole !== 'admin'}
              onClick={() => self.setState({ removeGroup: !self.state.removeGroup })}
            >
              <DeleteIcon className="buttonLabelIcon" />
              Remove group
            </Button>
          ) : null}
          <AuthorizedDevices
            acceptedCount={acceptedDevices}
            addDevicesToGroup={this._addDevicesToGroupBind}
            allowDeviceGroupRemoval={allowDeviceGroupRemoval}
            devices={this.state.devices}
            group={groupName}
            groupCount={groupCount}
            loading={this.state.loading}
            onPageChange={this._handlePageChangeBind}
            openSettingsDialog={this.props.openSettingsDialog}
            pageNo={self.state.pageNo}
            pageLength={self.state.pageLength}
            refreshDevices={this._getAllDataBind}
            removeDevicesFromGroup={this._removeDevicesFromGroupBind}
            updateRefreshTimer={this._triggerRefreshTimerBind}
            count={this.state.count}
            redirect={this.props.redirect}
          />
        </div>

        <Dialog open={this.state.addGroup} fullWidth={true} maxWidth="sm">
          <DialogTitle>Add selected devices to group</DialogTitle>
          <DialogContent>
            <GroupSelector
              devices={this.state.tmpDevices.length}
              willBeEmpty={this.state.willBeEmpty}
              tmpGroup={this.state.tmpGroup}
              selectedGroup={this.state.selectedGroup}
              selectedGroupName={groupName}
              changeSelect={group => this._changeTmpGroup(group)}
              validateName={(invalid, group) => this._validate(invalid, group)}
              groups={this.state.groups.filter(group => !this._isUngroupedGroup(group))}
              selectedField={this.state.selectedField}
            />
          </DialogContent>
          <DialogActions>{addActions}</DialogActions>
        </Dialog>

        <Dialog open={this.state.removeGroup}>
          <DialogTitle>Remove this group?</DialogTitle>
          <DialogContent>
            <p>This will remove the group from the list. Are you sure you want to continue?</p>
          </DialogContent>
          <DialogActions>{removeActions}</DialogActions>
        </Dialog>

        <CreateGroup
          toggleDialog={this._toggleDialogBind}
          open={this.state.createGroupDialog}
          groups={this.state.groups}
          changeGroup={this._handleGroupChangeBind}
          addListOfDevices={this._createGroupFromDialogBind}
        />
      </div>
    );
  }
}
